import { useUnavailability } from '@hooks';
import { observer } from 'mobx-react';
import Presentation from './UnavailabilityTable.presentation';
import { useCallback } from 'react';
import { useStore } from '@stores';

interface IProps {
  userId?: number;
  workStationId?: string;
}

export const UnavailabilityTable: React.FC<IProps> = observer(({ userId, workStationId }) => {
  const { unavailabilityStore } = useStore();
  const unavailabilityHook = useUnavailability({ userId, workStationId });

  const handleDelete = useCallback(
    async (id: string) => await unavailabilityStore.delete(id),
    [unavailabilityStore]
  );

  return <Presentation unavailabilityHook={unavailabilityHook} handleDelete={handleDelete} />;
});
